// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"Requests__materialize-textarea___1Kq2S","modal-2463794813":"Requests__modal-2463794813___2FxIO","container":"Requests__container___3JiVD","adaptContainer":"Requests__adaptContainer___twIFY","emptyScreens":"Requests__emptyScreens___3j2bV","emptyImage":"Requests__emptyImage___3b-Gw","noDescFound":"Requests__noDescFound___1PSNM","studentShowedInterest":"Requests__studentShowedInterest___73z5N","fromToContainer":"Requests__fromToContainer___2EYIw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Requests/Requests.scss
// module id = 1522
// module chunks = 0